import React from "react";
import DisplayCardList from "../../../componenets/DisplayCardList";
import { projectsData } from "../../../data";

const Projects = () => {
  return (
    <>
      <DisplayCardList data={projectsData} />
    </>
  );
};

export default Projects;
